import { IOperationsTabConfig } from '../types'
import { issuesTab } from './issues'
import { ordersTab } from './orders'
import { refundsTab } from './refunds'
import { catalogTab } from './catalog'
import { promotionsTab } from './promotions'

/**
 * Registry of Operations tabs. Each tab lives in its own directory under ./ and exports its tab
 * config (label, metric fetcher, and content panel). Add a tab by creating its directory and
 * appending its config here — the page shell (../index.tsx) needs no changes.
 */
export const OPERATIONS_TABS: IOperationsTabConfig[] = [
    issuesTab,
    ordersTab,
    refundsTab,
    catalogTab,
    promotionsTab,
]
